export default "__VITE_ASSET__BJzgGa5P__"